
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("form/mood-comment",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"unstar\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"status.starredBestMoment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":63},"end":{"line":1,"column":100}}})) != null ? stack1 : "")
    + "\" style=\"color:#FF6C87;\" >"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_added_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":126},"end":{"line":1,"column":161}}}))
    + "</icon> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"star\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.starBestMoment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":214},"end":{"line":1,"column":249}}})) != null ? stack1 : "")
    + "\" >"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":252},"end":{"line":1,"column":285}}}))
    + "</icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"moodStarShortcut") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":300}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;